<template>
  <div class="second-step">
    <FacilityDocuForm
        ref="facilityDocuForm"
        @dialogClosed="() => {$emit('dialogClosed')}"
        @cancelDialog="cancelDialog"
        hide-button
        :isGlobal="true"
    />
  </div>
</template>

<script>
import FacilityDocuForm from '@/modules/book/views/facility/facility/formDialogs/form/FacilityDocuForm.vue';

export default {
  name: 'CreateGlobalDocumentationStep',
  components: {FacilityDocuForm},
  data() {
    return {
      inputData: {}
    }
  },
  methods: {
    save() {
      this.$refs.facilityDocuForm.uploadFacilityDocumentation();
    },
    setInputData(inputData) {
      this.inputData = inputData;
      this.$refs.facilityDocuForm.uploadAsUrl(inputData.file);
      this.$refs.facilityDocuForm.loadEnums();
    },
    cancelDialog() {
      this.$refs.facilityDocuForm.clearForm();
      this.inputData = {}
    }
  }
}
</script>